import { Button } from '@mantine/core'

export function CustomButtonNew({
    onClick,
    className = '',
    label = 'button',
    ariaLabel = 'submit-button',
    c = '#000',
    bg = '#fff',
}: {
    onClick: () => void
    className: string
    label: string
    ariaLabel: string
    c: string
    bg: string
}) {
    return (
        <Button
            onClick={onClick}
            aria-label={ariaLabel}
            className={`${className}`}
            radius='sm'
            c={c}
            bg={bg}
            size='xs'
        >
            {label}
        </Button>
    )
}


